import { render, staticRenderFns } from "./CxMessageToast.vue?vue&type=template&id=07987fab&scoped=true"
import script from "./CxMessageToast.vue?vue&type=script&lang=js"
export * from "./CxMessageToast.vue?vue&type=script&lang=js"
import style0 from "./CxMessageToast.vue?vue&type=style&index=0&id=07987fab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07987fab",
  null
  
)

export default component.exports